module.exports = __webpack_public_path__ + "img/activesavejobs.cc1d7e76.svg";